import {
  Box,
  Button,
  CircularProgress,
  Drawer,
  List,
  ListItem,
  Stack,
  Typography,
} from '@mui/material';
import { useFullTimeJobPostApplicants } from 'admin/hooks';
import { IExpert, IJobPost } from 'common/models';

export const ApplicationDrawer = ({
  open,
  jobPost,
  onClose,
  onSelectApplicant,
}: {
  open: boolean;
  jobPost: IJobPost;
  onClose: () => void;
  onSelectApplicant: (applicant: IExpert | undefined) => void;
}) => {
  const { applicants, isLoading } = useFullTimeJobPostApplicants(jobPost.id);

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 350 }} onClick={onClose}>
        <Stack px={4} py={6} spacing={4}>
          <Typography variant="subtitle1">{`Applicants of ${jobPost.title}`}</Typography>
          {isLoading ? (
            <CircularProgress />
          ) : applicants.length > 0 ? (
            <List>
              {applicants.map((applicant, index) => (
                <ListItem key={applicant.id}>
                  <Box display="flex" alignItems="center" gap={2}>
                    <Typography>{`${index + 1}. `}</Typography>
                    <Button onClick={() => onSelectApplicant(applicant)}>
                      {applicant.name}
                    </Button>
                  </Box>
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="subtitle2">
              No application submitted yet
            </Typography>
          )}
        </Stack>
      </Box>
    </Drawer>
  );
};
